import React from 'react';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router';
import { connect } from 'react-redux';
import { Toolbar, ToolbarGroup } from 'material-ui/Toolbar';

import { search } from '../../../store/ui/actions';
import { getAchievements } from '../../../store/achievements/actions';
import { fetchApp } from '../../../store/apps/actions';
import withTranslation from '../../../hoc/withTranslation';
import Loading from '../../../components/common/Loading/Loading';
import styles from './GamificationPage.css';
import AchievementList from '../../../components/achievement/AchievementList/AchievementList';
import SearchBox from '../../../components/common/SearchBox/SearchBox';
import AdminService, { ADMIN } from '../../../services/admin';
import { FloatingActionButton } from 'material-ui';
import ContentAdd from 'material-ui/svg-icons/content/add';
import { ADD_ACHIEVEMENT_PAGE } from '../../../constants/routes';
import { getUserAchievements } from '../../../store/userachievements/actions';
import UserAchievementList
    from '../../../components/achievement/UserAchievementList/UserAchievementList';

export class GamificationPage extends React.Component {

    static propTypes = {
        app: PropTypes.object,
        match: PropTypes.object,
        currentLang: PropTypes.string,
    };
    static defaultProps = {
        loading: true,
        app: null,
    };

    componentWillMount() {
        this.fetchApplication();
        if (this.props.app && this.props.currentLang) {
            this.props.getAchievements(this.props.app, this.props.currentLang);
            this.props.getUserAchievements(this.props.app, this.props.currentLang, 'json', 10);
        }
    }

    fetchApplication(appId = null) {
        if (this.props.match) {
            const id = appId || this.props.match.params.appId;
            if (id) {
                this.props.fetchApp(id);
            }
        }
    }

    componentWillReceiveProps(nextProps) {
        if (this.props.match !== nextProps.match) {
            this.fetchApplication(nextProps.match.params.appId);
        }
        if (
            this.props.app !== nextProps.app
            && nextProps.app
            && nextProps.currentLang
            && !this.props.loading
            && !nextProps.loading
        ) {
            this.props.getAchievements(nextProps.app, nextProps.currentLang);
        }
        if (
            this.props.app !== nextProps.app
            && nextProps.app
            && !this.props.userAchievementsPending
            && !nextProps.userAchievementsPending
        ) {
            this.props.getUserAchievements(nextProps.app, nextProps.currentLang, 'json', 10);
        }
    }

    onSearchChanged = (event, value) => {
        this.props.search(value);
    };

    toolbarContainerStyle() {
        let style = styles.toolBar.container;

        style = {
            ...style,
            ...styles.toolBar.containerList,
        };

        return style;
    }

    filteredAchievements() {
        if (
            this.props.achievements[this.props.currentLang] === undefined
            || this.props.achievements[this.props.currentLang] === null
            || this.props.achievements[this.props.currentLang].length === 0
        ) {
            return [];
        }
        const { searchValue } = this.props;

        if (!searchValue || searchValue.length === 0) {
            return this.props.achievements[this.props.currentLang];
        }

        return this.props.achievements[this.props.currentLang].filter((ac) => {
            const includesName = ac.name
                && ac.name.toLowerCase().includes(searchValue.toLowerCase());
            const includesDesc = ac.description
                && ac.description.toLowerCase().includes(searchValue.toLowerCase());
            return includesName || includesDesc;
        });
    }

    renderFloatingButton() {
        return (
            <div>
                <FloatingActionButton
                    style={styles.floatingButton}
                    onClick={() => {
                        this.props.history.push(
                            ADD_ACHIEVEMENT_PAGE.replace(':appId', this.props.app.id),
                        );
                    }}
                >
                    <ContentAdd />
                </FloatingActionButton>
            </div>
        );
    }

    render() {
        if (!this.props.app || this.props.loading) {
            return <Loading paper={false} />;
        }
        const achievements = this.filteredAchievements() || [];
        return (
            <div style={styles.container}>
                <Toolbar style={this.toolbarContainerStyle()}>
                    <ToolbarGroup firstChild={true} style={styles.toolBar.searchBar}>
                        <SearchBox
                            onChange={this.onSearchChanged}
                            value={this.props.searchValue}
                        />
                    </ToolbarGroup>
                </Toolbar>
                <div>
                    <div style={styles.list.container}>
                        <AchievementList
                            app={this.props.app}
                            user={this.props.user}
                            achievements={achievements}
                            title={this.props.t('module.gamification.achievements')}
                            currentLang={this.props.currentLang}
                        />
                    </div>
                    <div style={styles.list.userAchievementContainer}>
                        {this.props.userAchievementsPending && <Loading paper={false} />}
                        {!this.props.userAchievementsPending
                            && !this.props.userAchievementsError
                            && this.props.userAchievements
                            && <UserAchievementList
                                app={this.props.app}
                                userAchievements={this.props.userAchievements}
                                title={this.props.t('module.gamification.last_user_achievements')}
                                lang={this.props.currentLang}
                            />
                        }
                    </div>
                </div>
                {AdminService.isAuthorized(ADMIN, this.props.user) && this.renderFloatingButton()}
            </div>
        );
    }
}

function mapStateToProps(state, ownProps) {
    let props = {
        sending: state.achievements.sending,
        loading: state.achievements.pending,
        achievements: state.achievements.content,
        currentLang: state.ui.currentLang,
        searchValue: state.ui.search,
        user: state.auth.content,
        userAchievementsPending: state.userAchievements.pending,
        userAchievements: state.userAchievements.content,
        userAchievementsError: state.userAchievements.error,
    };
    if (state.apps.currentApplication) {
        props.app = state.apps.currentApplication;
    }
    return props;
}

export default connect(mapStateToProps, {
    fetchApp,
    getAchievements,
    getUserAchievements,
    search,
})(withRouter(withTranslation(GamificationPage)));



// WEBPACK FOOTER //
// src/containers/gamification/GamificationPage/GamificationPage.js